import { Heart } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { http } from "../../lib/api";
import { useAuth, apiError } from "../../context/AuthContext";

export const FavoriteButton = ({ slug, className = "" }) => {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const on = !!user && user.favorites?.includes(slug);
  const toggle = async (e) => {
    e.preventDefault();
    if (!user) {
      toast("Sign in to save favorites");
      return navigate(`/login?next=${encodeURIComponent(window.location.pathname)}`);
    }
    try {
      const r = await http.post(`/account/favorites/${slug}`);
      setUser({ ...user, favorites: r.data.favorites });
      toast.success(r.data.favorited ? "Saved to favorites" : "Removed from favorites");
    } catch (err) {
      toast.error(apiError(err));
    }
  };
  return (
    <button onClick={toggle} aria-label={on ? "Remove from favorites" : "Save to favorites"} aria-pressed={on}
      className={`w-11 h-11 rounded-full bg-white/90 backdrop-blur grid place-items-center shadow transition-transform hover:scale-110 ${className}`} data-testid={`favorite-button-${slug}`}>
      <Heart className={`w-5 h-5 ${on ? "fill-tpink text-tpink" : "text-navy"}`} />
    </button>
  );
};
